import React,{useState} from 'react';
import { View, Text, TextInput, Switch } from 'react-native';
import styles from '@stylesheet';
import { ValidationType } from '../types/validatorTypes';
import updateStoreHandler from '../utils/updateStoreHandler';
import ComponentRenderer from './ComponentRenderer';
import defaultValComponents, { ValidationComponentType } from '../utils/defaultValComponents';

const LocationValidation = ({item, index }: ValidationType) => {

  // Define an array of configuration objects for each component
  const validationComponents: ValidationComponentType[] = [
    ...defaultValComponents,
    { key: 'allowedCountries', label: 'Allowed Countries', type: 'textInput' },
    { key: 'allowedStates', label: 'Allowed States', type: 'textInput' },
    { key: 'allowedAreas', label: 'Allowed Areas', type: 'textInput' },
    { key: 'maxDistance', label: 'Max Distance', type: 'textInput', inputMode: 'numeric' },
  ];



  return (
    <View style={[styles.validationView, { flexWrap: 'wrap' }]}>
      {validationComponents.map((component) => (
        <View key={component.key} style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', position: 'relative', flexWrap: 'wrap' }}>
          {
            component.type === 'switch' &&
            <Text style={{ flex: 1 }}>{component.label}</Text>
          }
          <ComponentRenderer item={item} component={component} index={index} />
        </View>
      ))}
    </View>
  );
};

export default LocationValidation;
